const EXPLICIT_TIMEZONE = /(Z|[+-]\d{2}:\d{2})$/i

export function formatShanghaiTime(
  value: string,
  options: Intl.DateTimeFormatOptions,
): string {
  const normalized = EXPLICIT_TIMEZONE.test(value) ? value : `${value}Z`
  return new Intl.DateTimeFormat("zh-CN", {
    ...options,
    timeZone: "Asia/Shanghai",
  }).format(new Date(normalized))
}
